// extracted by mini-css-extract-plugin
export default {"user":"UserDetails_user__li9ui","name":"UserDetails_name__EmM3t","email":"UserDetails_email__2PEnp","secondary":"UserDetails_secondary__KtG-m"};